import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { cancelSubscriptionOrder } from '@/api/apiRequests/orders';
import paths from '@/lib/consts/paths';

const SubscriptionCancelOrder: FC = () => {
	const { subscriptionId = '', orderId = '' } = useParams();
	const navigation = useNavigate();

	useEffect(() => {
		if (subscriptionId && orderId) {
			cancelSubscriptionOrder({
				subscriptionId: Number(subscriptionId),
				orderId: Number(orderId),
			})
				.then(() => {
					navigation(paths.plans);
				})
				.catch(() => {
					navigation(paths.plans);
				});
		}
	}, [subscriptionId, orderId]);

	return <div>Loading...</div>;
};

export default SubscriptionCancelOrder;
